import React, {useEffect, useState} from "react";
import "../AccountAttributes/List/AccountList.css";
import "../Dashboard/Sidebar";
import ReactPaginate from 'react-paginate';
import Header from "../layout/header";
import DashboardMenu from "../layout/dashboardMenu";
import Loader from "../../Loader/Loader";
import NotFoundData from "../../Images/no-data-found.webp";
import Moment from "moment/moment";
import '../main_2.css'
import BottomMenu from "../layout/bottomMenu";

const ExternalMomListing = (
    {
        externalMomListRequest,
        externalMomListResponse = [],
        match,
        fetchAssignee ,
        getAssignee = []
    }
) => {
    const [isLoading, setIsLoading] = useState(false)
    const [pageNo, setPage] = useState(1)
    const [roleId, setRoleId] = useState("")
    const [open, setOpen] = useState(false);
    const [filterInputList, setFilterInputList] = useState([{}])

    useEffect(async () => {
        let roleId = localStorage.getItem('role_id')
        setRoleId(roleId)
        setIsLoading(true)
        let filter = window.localStorage.external_mom_filter ? JSON.parse(window.localStorage.external_mom_filter) : [{}]
        setFilterInputList(filter)
        await externalMomListRequest(1, window.localStorage.module_type, filter)
        await fetchAssignee()
        setIsLoading(false)

    }, [])

    const onPageChange = async (val) => {
        setIsLoading(true)
        setPage(val?.selected + 1)
        await externalMomListRequest(val?.selected + 1, window.localStorage.module_type, filterInputList)
        setIsLoading(false)
    };

    const handleFilter = async (key, value, stringValue = '') => {
        const list = [...filterInputList]
        list[0][key] = value
        setFilterInputList(list)
    }

    const removeSearchFilter = async () => {
        delete window.localStorage.search_ucd_dealer
        setIsLoading(true)
        await externalMomListRequest(1, window.localStorage.module_type)
        setIsLoading(false)
    }

    const handleSubmitFilter = async () => {
        setOpen(false)
        setIsLoading(true)
        window.localStorage.external_mom_filter = JSON.stringify(filterInputList);
        await externalMomListRequest(1, window.localStorage.module_type, filterInputList)
        setIsLoading(false)
    }


    const handleRemoveFilter = async (key) => {
        if (key !== '') {
            delete filterInputList[0][key]
            setFilterInputList(filterInputList)
            if(filterInputList.length === 0){
                delete window.localStorage.external_mom_filter;
            } else {
                window.localStorage.external_mom_filter = JSON.stringify(filterInputList);
            }

            setIsLoading(true)
            await externalMomListRequest(1, window.localStorage.module_type, filterInputList)
            setIsLoading(false)
        }
    }
    return (
        <>
            {/*<Sidebar/>*/}
            {/* section start  */}
            <Loader isLoading={isLoading}/>
            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={'Mom List'}
                        />
                        {/* <InnerMobileHeader
                          title={'Account List'}
                         /> */}
                        <div className="container-fluid common-bg">
                            {/*Heading*/}
                            <div className="container-fluid bootstrap snippets bg-white">
                                <div className="row b-13">
                                    {/*<div className="form-check form-switch global-search">*/}
                                    {/*    <input type="checkbox" id="switch" onChange={(e) => setIsGlobalSearch(e.target.checked)}/>*/}
                                    {/*    <label className="radio-btn" for="switch">Global Search</label>*/}
                                    {/*    <span className="serach-title">Search account globally..</span>*/}
                                    {/*</div>*/}
                                </div>
                                <div className="d-sm-flex align-items-center justify-content-between mt-2 mb-2">
                                    <div className="row col-md-12">
                                        <div className="col-md-6 col-sm-6 d-flex mt-20px">
                                            <form className="form-inline mr-auto w-90 navbar-search">
                                                <div className="d-flex w-100 mb-6">
                                                    {/*<input type="text"*/}
                                                    {/*       className="form-control bg-light border-0 small list-filter"*/}
                                                    {/*       placeholder="Search Dealer..." aria-label="Search"*/}
                                                    {/*       aria-describedby="basic-addon2"*/}
                                                    {/*       onChange={(e) => {*/}
                                                    {/*           setSearchValue(e.target.value)*/}
                                                    {/*       }}*/}
                                                    {/*/>*/}
                                                    {/*<div className="remove-search-filter">*/}
                                                    {/*    <i className="fa fa-times" aria-hidden="true"*/}
                                                    {/*       onClick={removeSearchFilter}></i>*/}
                                                    {/*</div>*/}
                                                    {/*<div className="btn-search">*/}
                                                    {/*    <button className="btn btn-primary lh-32 border-left-tr-tb"*/}
                                                    {/*            type="button"*/}
                                                    {/*            onClick={(e) => handleSearch()}*/}
                                                    {/*    >*/}
                                                    {/*        <i className="fas fa-search fa-sm"></i>*/}
                                                    {/*    </button>*/}
                                                    {/*</div>*/}
                                                </div>
                                            </form>
                                             {/*<h1 className="h3 mb-0 text-black-100">Accounts</h1> */}
                                        </div>
                                        <div className="col-md-6 cs-pos mb-3">
                                            <button onClick={() => setOpen(!open)}
                                                    className="btn btn-sm btn-primary mr-1 btn-filter"
                                                    type="button"><i
                                                className="fa fa-filter lh-35 pd-3"></i>
                                            </button>
                                        </div>
                                    </div>
                                    {/* Filter View */}
                                    {filterInputList[0] !== undefined && Object.keys(filterInputList[0]).length > 0 &&
                                        <div className="d-sm-flex align-items-center justify-content-between mb-4">
                                            <div className="row pd-filter-div mt-4">
                                                <div className="col-md-12 col-sm-12 d-flex">
                                                    <div className="applied-filter">
                                                        {Object.keys(filterInputList[0]).map((val, i) => {
                                                            return (
                                                                <>
                                                                    {console.log(val)}
                                                                <span className="fd-1">
                                                                    <span style={{textTransform: "capitalize"}}>
                                                                        {val.replaceAll("_", " ")}
                                                                    </span>
                                                                    {val === 'created_by' ?
                                                                    getAssignee.map(value => {
                                                                        return (
                                                                            <>
                                                                                {parseInt(value?.id) === parseInt(filterInputList[0][val]) &&
                                                                                    <>
                                                                                        {" - " + value?.name}
                                                                                    </>
                                                                                }
                                                                            </>
                                                                        )
                                                                    }) : <>
                                                                            {" - " + filterInputList[0][val]}
                                                                        </>}
                                                                    <i className="bi bi-x-circle" onClick={(e) => {
                                                                        handleRemoveFilter(val)
                                                                    }}></i></span>
                                                                </>
                                                            )
                                                        })}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    {/* Filter View End*/}
                                </div>
                                {/* Filter View End*/}
                                <div className="row">
                                    {/*CARD START*/}
                                    {externalMomListResponse && externalMomListResponse?.data !== undefined && externalMomListResponse?.data !== [] && externalMomListResponse?.data.map((val, i) => {
                                        return (
                                            <>
                                                <div className="col-md-4 col-sm-6">
                                                    <div className="card-big-shadow">
                                                        <div className="card card-just-text" data-background=""
                                                             data-color=""
                                                             data-radius="none">
                                                            <div className="content">
                                                                <h6 className="category mrg-b-12">
                                                                    <div className="header-ui-item-opp"
                                                                         style={{backgroundColor: "#bea925"}}>
                                                                        {val?.mom_status}
                                                                    </div>
                                                                    <div className="row list-view">
                                                                        {val?.account_details?.client_name &&
                                                                            <div className="mb-flex">
                                                                                <div
                                                                                    className="col-md-6 col-sm-6 no-wrap">
                                                                                    <i className="fa fa-book"
                                                                                       aria-hidden="true"></i>&nbsp;&nbsp;Site
                                                                                </div>
                                                                                <div className="col-md-6 col-sm-6 l2">
                                                                                    <span className="trigger"
                                                                                          data-tooltip-id="1"
                                                                                          title={val?.account_details?.client_name}>{val?.account_details?.client_name}</span>
                                                                                </div>
                                                                            </div>
                                                                        }

                                                                        {val?.activity_type?.name &&
                                                                            <div className="mb-flex">
                                                                                <div
                                                                                    className="col-md-6 col-sm-6 no-wrap">
                                                                                    <i className="fa fa-book"
                                                                                       aria-hidden="true"></i>&nbsp;&nbsp;Activity Type
                                                                                </div>
                                                                                <div className="col-md-6 col-sm-6 l2">
                                                                                    <span className="trigger"
                                                                                          data-tooltip-id="1"
                                                                                          title={val?.activity_type?.name}>{val?.activity_type?.name}</span>
                                                                                </div>
                                                                            </div>
                                                                        }

                                                                        <div className="mb-flex">
                                                                            <div
                                                                                className="col-md-6 col-sm-6 no-wrap">
                                                                                <i className="fas fa-calendar-alt"></i>&nbsp;&nbsp;Created
                                                                                Date
                                                                            </div>
                                                                            <div
                                                                                className="col-md-6 col-sm-6">
                                                                                    <span className="trigger"
                                                                                          data-tooltip-id="1"
                                                                                          title={Moment(val?.created_at).format('DD-MM-YYYY')}>
                                                                                        {Moment(val?.created_at).format('DD-MM-YYYY')}
                                                                                    </span>
                                                                            </div>
                                                                        </div>
                                                                        <div className="mb-flex">
                                                                            <div
                                                                                className="col-md-6 col-sm-6 no-wrap">
                                                                                <i className="bi bi-person-lines-fill"></i>&nbsp;&nbsp;Created
                                                                                By
                                                                            </div>
                                                                            <div
                                                                                className="col-md-6 col-sm-6">
                                                                                    <span className="trigger"
                                                                                          data-tooltip-id="1"
                                                                                          title={val?.user?.email}>
                                                                                        {val?.user?.email}
                                                                                    </span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <hr/>
                                                                </h6>
                                                                <div className="row list-view-links">
                                                                    <ul>
                                                                        <li>
                                                                            <a style={{color: "rgb(149 150 40)"}}
                                                                               href={`valet-external-mom/${val?.id}`}
                                                                               className="btn btn-sm"
                                                                               type="button"
                                                                            >External MOM</a>
                                                                        </li>
                                                                        <li><a style={{color: "rgb(149 150 40)"}}
                                                                            href={`external-mom-list/${val?.id}`}
                                                                            className="btn btn-sm"
                                                                            type="button"
                                                                        >Mom List</a>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                                {/*<div className="col-sm-6">*/}
                                                                {/*    <a href={`valet-external-mom/${match?.params?.meeting_id}`}*/}
                                                                {/*       className="draft-float">*/}
                                                                {/*        <p className="my-float"*/}
                                                                {/*           style={{marginTop: "20px"}}><i*/}
                                                                {/*            className="fa fa-plus"*/}
                                                                {/*            aria-hidden="true"></i></p>*/}
                                                                {/*    </a>*/}
                                                                {/*</div>*/}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        )
                                    })}

                                    {externalMomListResponse && externalMomListResponse?.data !== undefined && externalMomListResponse?.data.length > 0 &&
                                        <div className="panel-pagination-col panel-table-pagination">
                                            <ReactPaginate
                                                previousLabel={'<'}
                                                nextLabel={'>'}
                                                breakLabel={'...'}
                                                breakClassName={'break-me'}
                                                pageCount={(externalMomListResponse?.total / externalMomListResponse?.per_page)}
                                                forcePage={externalMomListResponse?.current_page - 1}
                                                pageRangeDisplayed={4}
                                                onPageChange={onPageChange}
                                                activeClassName={'active'}
                                            />
                                        </div>
                                    }

                                    {externalMomListResponse && externalMomListResponse?.data !== undefined && externalMomListResponse?.data.length === 0 &&
                                        <>
                                            <img src={NotFoundData} className="not-found-data"/>
                                            <div className="text-center" style={{"width": "100%"}}>
                                                Data Not Found
                                            </div>
                                            {/*<div className="col-sm-6">*/}
                                            {/*    <a href={`valet-external-mom/${match?.params?.meeting_id}`}*/}
                                            {/*       className="draft-float">*/}
                                            {/*        <p className="my-float" style={{marginTop: "20px"}}><i*/}
                                            {/*            className="fa fa-plus"*/}
                                            {/*            aria-hidden="true"></i></p>*/}
                                            {/*    </a>*/}
                                            {/*</div>*/}
                                        </>
                                    }
                                    {/*PAGINATION END*/}
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <BottomMenu
                    open={open}
                    setOpen={setOpen}
                    handleSubmitFilter={handleSubmitFilter}
                    filterContent={{data: [{'field': 'dropdown', 'place_holder': 'Status', 'values': [{id:'Pending', name:"Pending"}, {id:"Completed", name:"Completed"}]}, {'field': 'dropdown', 'place_holder': 'Created_by', 'values': getAssignee}]}}
                    handleFilter={handleFilter}
                    // setIsRemoveFilter={setIsRemoveFilter}
                />
            </div>
            {/* section ends */}
        </>
    )
}

export default ExternalMomListing